import { Flex } from '@byecode/ui'
import styled, { css } from 'styled-components'

export const Desktop = styled.div`
    border-top: 1px solid #c5c5c5;
    border-left: 1px solid #c5c5c5;
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 6px 0px #3838381f;
    border-radius: 10px 0px 0px 0px;
    background: linear-gradient(137.8deg, #f7f9fb 4.58%, #fbf7fb 27.14%, #f8fcfc 75.88%);
`

export const WxApplet = styled.div`
    width: 330px;
    height: 691px;
    box-shadow: 0px 0px 6px 0px #3838381f;
    border-radius: 20px;
    overflow: hidden;
    background: linear-gradient(137.8deg, #f7f9fb 4.58%, #fbf7fb 27.14%, #f8fcfc 75.88%);
`

export const Mobile = styled.div`
    position: absolute;
    top: 221px;
    left: 65px;
    width: 330px;
    height: 100%;
    box-shadow: 0px 0px 6px 0px #3838381f;
    border-radius: 20px;
    overflow: hidden;
    background: linear-gradient(137.8deg, #f7f9fb 4.58%, #fbf7fb 27.14%, #f8fcfc 75.88%);
`

export const Header = styled.div`
    width: 100%;
    height: 50px;
    background-color: #e8eaed;
    border-radius: 10px 0px 0px 0px;
    padding-top: 14px;
`

export const HeaderContent = styled.div`
    position: relative;
    height: 36px;
    width: 275px;
    background-color: var(--color-white);
    display: flex;
    flex-direction: row;
    padding: 0 7px;
`

export const HeaderHalf = styled.div`
    width: 100%;
    height: 18px;
    position: absolute;
    top: 0px;
    background-color: #e8eaed;
    z-index: 1;
`

export const Prefix = styled.div`
    position: absolute;
    left: 0;
    width: 7px;
    height: 100%;
    background-color: #e8eaed;
    border-radius: 0px 0px 10px 0px;
`

export const Suffix = styled.div`
    position: absolute;
    right: -1px;
    width: 8px;
    height: 100%;
    background-color: #e8eaed;
    border-radius: 0 0px 0px 10px;
`

export const WebTab = styled.div`
    height: 36px;
    width: 275px;
    border-radius: 10px 10px 0 0;
    background-color: var(--color-white);
    z-index: 2;
    padding: 0 10px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
`

export const Title = styled.div`
    color: #161616;
    margin-left: 8px;
`

export const ToolBar = styled(Flex)<{ height: number; borderBottom?: boolean }>`
    height: ${({ height }) => `${height}px`};
    border-bottom: ${({ borderBottom }) => borderBottom && '1px solid #c5c5c5'};
    background-color: var(--color-white);
`

// export const Tool = styled(Flex)`
//     display: flex;
//     flex-flow: row nowrap;
//     gap: 20px;
// `

export const Address = styled(Flex)`
    flex: 1;
    height: 30px;
    border-radius: 15px 0 0 15px;
    background-color: #f1f3f4;
    padding-left: 16px;
`

export const MobileAddress = styled(Flex)`
    flex: 1;
    height: 33px;
    border-radius: 15px;
    background-color: #f1f3f4;
    padding-left: 16px;
`

export const Url = styled.div`
    font-size: 12px;
    white-space: nowrap;
    color: #161616;
`

export const Content = styled.div<{ isHorizontal?: boolean; background?: string }>`
    background-color: ${({ background }) => background || 'var(--color-white)'};
    ${({ isHorizontal }) =>
        isHorizontal
            ? css`
                  width: 100%;
                  height: 60px;
                  padding-left: 16px;
                  display: flex;
                  align-items: center;
              `
            : css`
                  width: 240px;
                  height: 100%;
                  padding: 23px 40px;
              `}
`

export const AppHeader = styled.div<{ isHorizontal?: boolean }>`
    ${({ isHorizontal }) =>
        isHorizontal
            ? css`
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  width: 100%;
                  gap: 40px;
              `
            : css`
                  display: flex;
                  flex-direction: column;
                  width: 240px;
                  height: 100%;
              `}
`

export const AppMobileContent = styled.div`
    display: grid;
    padding: 21px 24px;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
`

export const AppDesktopContent = styled.div`
    display: grid;
    width: 720px;
    flex-shrink: 0;
    padding: 81px 24px;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
`

export const Box = styled.div`
    background-color: #26415a0f;
    height: 140px;
    border-radius: 16px;
`

export const AppMobileHeader = styled(Flex)`
    width: 100%;
`

export const AppInfo = styled.div<{ isHorizontal?: boolean }>`
    overflow: hidden;
    ${({ isHorizontal }) =>
        isHorizontal
            ? css`
                  display: flex;
                  align-items: center;
                  gap: 12px;
              `
            : css`
                  display: flex;
                  flex-direction: column;
                  gap: 12px;
                  margin-bottom: 20px;
              `}
`

export const AppTitle = styled.div<{ color?: string; isHorizontal?: boolean }>`
    width: ${({ isHorizontal }) => (isHorizontal ? '120px' : '160px')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 20px;
    color: ${({ color }) => color || 'var(--color-black)'};
`

export const CrossBand = styled.div<{ width: number; height: number; borderRadius: number; background?: string; opacity?: number }>`
    width: ${({ width }) => `${width}px`};
    height: ${({ height }) => `${height}px`};
    border-radius: ${({ borderRadius }) => `${borderRadius}px`};
    background-color: ${({ background }) => background || 'var(--color-white)'};
    opacity: ${({ opacity }) => opacity || 1};
`

export const AppNavBar = styled.div<{ isHorizontal?: boolean }>`
    ${({ isHorizontal }) =>
        isHorizontal
            ? css`
                  flex: 1;
                  display: flex;
                  align-items: center;
                  gap: 32px;
                  justify-content: flex-end;
                  padding-right: 26px;
              `
            : css`
                  display: flex;
                  flex-direction: column;
                  padding: 8px 0;
                  gap: 32px;
              `}
`

export const AppNav = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`
